import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { io, Socket } from 'socket.io-client';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root',
})
export class UtilService {
  private readonly _socketInstance: Socket;
  constructor() {
    this._socketInstance = io(environment.baseUrl, {
      transports: ['websocket'],
    });
  }

  getAbsoluteUrl(url: string): string {
    return url.indexOf('http') !== -1 ? url : `${environment.baseUrl}${url}`;
  }

  getSocket(): Socket {
    return this._socketInstance;
  }

  startTimer(cb: (secLefts: number) => void, restart = false): NodeJS.Timeout {
    let val = sessionStorage.getItem('timer_end_at');
    if (restart || !val) {
      val = moment().add(6, 'minutes').toISOString();
      sessionStorage.setItem('timer_end_at', val);
    }

    let end = moment(val);
    return setInterval(() => {
      const diff = end.diff(moment(), 'seconds');
      cb(diff);
    }, 400);
  }
}
